/**
 * RTWO Explorer Platform — Public API
 * Phase 15 | Module ID: RTWO-EXPL-001
 * Version: 1.0.0-phase15
 *
 * Public exports for the RTWO Explorer Platform.
 *
 * Truthful Data Policy:
 * - No fake blocks, transactions, addresses, balances, assets, contracts, or search results.
 * - Explorer is NOT claimed as live or publicly deployed.
 *
 * Source: Explorer Platform (RTWO-EXPL-001)
 */

export {
  EXPL_ENGINE_VERSION,
  EXPLORER_STATUS_LABELS,
  EXPLORER_VIEW_STATUS_LABELS,
  EXPLORER_CONNECTION_STATUS_LABELS,
  RTWO_EXPLORER_DATA_SOURCES,
  RTWO_EXPLORER_VIEW_POLICIES,
} from './domain-models';

export { getExplorerPlatformEngine } from './explorer-engine';
